import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../shared/Loader";
import { useNotification } from "../toster-notification/NotificationContext";
import { authService } from "../../services/authService";
import { handleErrorNotification } from "../../utils/errorNotificatioMessage";


const VerifyEmailPage: React.FC = () => {

    const [verificationSuccess, setVerificationSuccess] = useState<boolean>(false);
    
    const [loading, setLoading] = useState<boolean>(true);

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const { notify } = useNotification();


    useEffect(() => {
        verifyEmailToken();
    }, [token]);

    //TO DO: maybe check domain
    const verifyEmailToken = async () => {

        if (!token) {
            notify("error", "Token nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await authService.verifyEmailToken(token);
            if (response.success) {
                setVerificationSuccess(true);
                notify("success", "Uspešna verifikacija email-a", "Tvoj email je uspešno potvrđen.");
            } else {
                setVerificationSuccess(false);
                notify("error", "Neuspešna verifikacija email-a", response.message || "Došlo je do greške pri verifikaciji email-a.");
            }
        } catch (error: any) {
            setVerificationSuccess(false);
            notify("error", "Neuspešna verifikacija email-a", "Došlo je do greške pri verifikaciji email-a.");
            handleErrorNotification(error, notify);
        }
        finally {
            setLoading(false);
        }
    };


    if (loading) {
        return <Loader />;
    }

    if (token===null) {
        return <div>Token nije prosleđen</div>
    }

    return (
        <section className="email-verification-section">
            <div className="w-layout-blockcontainer container w-container">
                <div className="sttings-content-wrapper padding-tb-20px center">

                    {verificationSuccess ? (
                        <div className="admin-settings-box-div after-register">
                            <div className="div-block-57 green">
                                <div className="div-block-56 green"></div>
                                <div className="description-text">
                                    <strong>Verifikacija uspešna</strong>
                                </div>
                            </div>
                            <div>
                                <div className="text-block-35">Email je uspešno potvrđen</div>
                                <div className="description-text">
                                    Tvoj nalog je aktiviran. Sada možeš da se prijaviš i nastaviš sa korišćenjem aplikacije.<br />
                                </div>
                            </div>
                            <div className="div-block-59">
                                <div className="button-primary width-300px" onClick={() => navigate("/login")}>
                                    <div>Prijavi se</div>
                                </div>
                                <div className="button-secondary" onClick={() => navigate("/")}>
                                    <div>Idi na početnu</div>
                                </div>
                            </div>
                            <div className="div-block-58 temp">
                                <div className="description-text">Ako se ništa ne dešava nakon klika, slobodno zatvori ovu stranicu i nastavi u aplikaciji.</div>
                            </div>
                        </div>
                    ) : (
                        <div className="admin-settings-box-div after-register">
                            <div className="div-block-57 red">
                                <div className="div-block-56 _1rem-bold"></div>
                                <div className="description-text bold">Verifikacija neuspešna</div>
                            </div>
                            <div>
                                <div className="text-block-35">Ne možemo da potvrdimo email</div>
                                <div className="description-text">
                                    Link nije validan, istekao je ili je već iskorišćen. Izaberi opciju ispod da nastaviš.<br />
                                </div>
                            </div>
                            <div className="div-block-59">
                                <div className="button-primary width-300px" onClick={() => navigate("/after-register")}>
                                    <div>Pošalji novi link</div>
                                </div>
                                <div className="button-secondary" onClick={() => navigate("/login")}>
                                    <div>Prijavi se</div>
                                </div>
                            </div>
                            <div className="div-block-58 temp red">
                                <div className="description-text">Ako si već potvrdio email ranije, samo se prijavi. Ako često dobijaš ovu grešku, zatraži novi link.</div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </section>

    );

};

export default VerifyEmailPage;